import { render } from "./ErrorAlert.vue?vue&type=template&id=752f4f5a&scoped=true&ts=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts"

import "./ErrorAlert.vue?vue&type=style&index=0&id=752f4f5a&scoped=true&lang=css"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752f4f5a"]])

export default __exports__